import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {Currency} from "@pg-rp/common-types";

import {AdditionalFormFieldType} from "../types/AdditionalFormFieldType";
import {ILeadModalLeadType} from "../types/ILeadModalLeadType";
import {MainLeadDataPayload} from "../types/MainLeadDataPayload";
import {MainLeadState} from "../types/MainLeadState";

const initialState: MainLeadState = {
    isModalOpen: false,
    vendorId: null,
    offerId: null,
    propertyId: null,
    consultant: null,
    mainLeadType: null,
    applicationVariant: null,
    source: null,
    sourceSection: null,
    hideQuestions: false,
    affiliation: null,
    forceClose: false,
    creditPayload: null,
    salesOfficeId: null,
    initialStep: null,
    preventClosingWhenNoData: false,
    customSourceSection: null,
    customFormText: null,
    useAdditionalFormField: undefined,
    hourOptions: undefined,
    currency: Currency.PLN,
    topic: {
        type: null,
        title: null,
        message: null
    },
    gtmMeta: {
        openButtonSourceText: null,
        openButtonSource: null
    }
};

export const mainLeadSlice = createSlice({
    name: "mainLead",
    initialState,
    reducers: {
        openLeadModal: (state, action: PayloadAction<MainLeadDataPayload>) => {
            state.isModalOpen = true;

            state.vendorId = action.payload.vendorId;
            state.offerId = action.payload.offerId || initialState.offerId;
            state.propertyId = action.payload.propertyId || initialState.vendorId;
            state.source = action.payload.source;
            state.sourceSection = action.payload.sourceSection;
            state.applicationVariant = action.payload.applicationVariant || initialState.applicationVariant;
            state.hideQuestions = action.payload.hideQuestions || initialState.hideQuestions;
            state.affiliation = action.payload.affiliation || initialState.affiliation;
            state.forceClose = action.payload.forceClose || initialState.forceClose;
            state.creditPayload = action.payload.creditPayload || initialState.creditPayload;
            state.salesOfficeId = action.payload.salesOfficeId || initialState.salesOfficeId;
            state.initialStep = action.payload.initialStep || initialState.initialStep;
            state.preventClosingWhenNoData = action.payload.preventClosingWhenNoData || initialState.preventClosingWhenNoData;
            state.customSourceSection = action.payload.customSourceSection || initialState.customSourceSection;
            state.useAdditionalFormField = action.payload.useAdditionalFormField || state.useAdditionalFormField;
            state.hourOptions = action.payload.hourOptions || initialState.hourOptions;
            state.currency = action.payload.currency || initialState.currency;
            state.topic = action.payload.topic
                ? {
                      type: action.payload.topic.type || null,
                      title: action.payload.topic.title || null,
                      message: action.payload.topic.message || null
                  }
                : initialState.topic;
            state.gtmMeta.openButtonSourceText = action.payload.gtmMeta.openButtonSourceText || initialState.gtmMeta.openButtonSourceText;
            state.gtmMeta.openButtonSource = action.payload.gtmMeta.openButtonSource || initialState.gtmMeta.openButtonSource;
        },
        resetMainLeadData: () => {
            return initialState;
        },
        setMainLeadData: (state, action: PayloadAction<MainLeadDataPayload>) => {
            state.vendorId = action.payload.vendorId;
            state.offerId = action.payload.offerId || initialState.offerId;
            state.propertyId = action.payload.propertyId || initialState.vendorId;
            state.source = action.payload.source;
            state.sourceSection = action.payload.sourceSection;
            state.applicationVariant = action.payload.applicationVariant || initialState.applicationVariant;
            state.hideQuestions = action.payload.hideQuestions || initialState.hideQuestions;
            state.affiliation = action.payload.affiliation || initialState.affiliation;
            state.forceClose = action.payload.forceClose || initialState.forceClose;
            state.creditPayload = action.payload.creditPayload || initialState.creditPayload;
            state.salesOfficeId = action.payload.salesOfficeId || initialState.salesOfficeId;
            state.initialStep = action.payload.initialStep || initialState.initialStep;
            state.preventClosingWhenNoData = action.payload.preventClosingWhenNoData || initialState.preventClosingWhenNoData;
            state.customSourceSection = action.payload.customSourceSection || initialState.customSourceSection;
            state.useAdditionalFormField = action.payload.useAdditionalFormField || state.useAdditionalFormField;
            state.hourOptions = action.payload.hourOptions || initialState.hourOptions;
            state.currency = action.payload.currency || initialState.currency;
            state.topic = action.payload.topic
                ? {
                      type: action.payload.topic.type || null,
                      title: action.payload.topic.title || null,
                      message: action.payload.topic.message || null
                  }
                : initialState.topic;
            state.gtmMeta.openButtonSourceText = action.payload.gtmMeta.openButtonSourceText || initialState.gtmMeta.openButtonSourceText;
            state.gtmMeta.openButtonSource = action.payload.gtmMeta.openButtonSource || initialState.gtmMeta.openButtonSource;
        },
        setPriceConversationConsultant: (state, action: PayloadAction<MainLeadState["consultant"]>) => {
            state.consultant = action.payload;
        },
        setLeadModalMainLeadType: (state, action: PayloadAction<ILeadModalLeadType>) => {
            state.mainLeadType = action.payload;
        },
        setUseAdditionalFormField: (state, action: PayloadAction<AdditionalFormFieldType>) => {
            state.useAdditionalFormField = action.payload;
        }
    }
});

export const {openLeadModal, resetMainLeadData, setMainLeadData, setPriceConversationConsultant, setLeadModalMainLeadType, setUseAdditionalFormField} =
    mainLeadSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {Currency} from "@pg-rp/common-types";

import {AdditionalFormFieldType} from "../types/AdditionalFormFieldType";
import {ILeadModalLeadType} from "../types/ILeadModalLeadType";
import {MainLeadDataPayload} from "../types/MainLeadDataPayload";
import {MainLeadState} from "../types/MainLeadState";

const initialState: MainLeadState = {
    isModalOpen: false,
    vendorId: null,
    offerId: null,
    propertyId: null,
    consultant: null,
    mainLeadType: null,
    applicationVariant: null,
    source: null,
    sourceSection: null,
    hideQuestions: false,
    affiliation: null,
    forceClose: false,
    creditPayload: null,
    salesOfficeId: null,
    initialStep: null,
    preventClosingWhenNoData: false,
    customSourceSection: null,
    customFormText: null,
    useAdditionalFormField: undefined,
    hourOptions: undefined,
    currency: Currency.PLN,
    topic: {
        type: null,
        title: null,
        message: null
    },
    gtmMeta: {
        openButtonSourceText: null,
        openButtonSource: null
    }
};

export const mainLeadSlice = createSlice({
    name: "mainLead",
    initialState,
    reducers: {
        openLeadModal: (state, action: PayloadAction<MainLeadDataPayload>) => {
            state.isModalOpen = true;

            state.vendorId = action.payload.vendorId;
            state.offerId = action.payload.offerId || initialState.offerId;
            state.propertyId = action.payload.propertyId || initialState.vendorId;
            state.source = action.payload.source;
            state.sourceSection = action.payload.sourceSection;
            state.applicationVariant = action.payload.applicationVariant || initialState.applicationVariant;
            state.hideQuestions = action.payload.hideQuestions || initialState.hideQuestions;
            state.affiliation = action.payload.affiliation || initialState.affiliation;
            state.forceClose = action.payload.forceClose || initialState.forceClose;
            state.creditPayload = action.payload.creditPayload || initialState.creditPayload;
            state.salesOfficeId = action.payload.salesOfficeId || initialState.salesOfficeId;
            state.initialStep = action.payload.initialStep || initialState.initialStep;
            state.preventClosingWhenNoData = action.payload.preventClosingWhenNoData || initialState.preventClosingWhenNoData;
            state.customSourceSection = action.payload.customSourceSection || initialState.customSourceSection;
            state.useAdditionalFormField = action.payload.useAdditionalFormField || state.useAdditionalFormField;
            state.hourOptions = action.payload.hourOptions || initialState.hourOptions;
            state.currency = action.payload.currency || initialState.currency;
            state.topic = action.payload.topic
                ? {
                      type: action.payload.topic.type || null,
                      title: action.payload.topic.title || null,
                      message: action.payload.topic.message || null
                  }
                : initialState.topic;
            state.gtmMeta.openButtonSourceText = action.payload.gtmMeta.openButtonSourceText || initialState.gtmMeta.openButtonSourceText;
            state.gtmMeta.openButtonSource = action.payload.gtmMeta.openButtonSource || initialState.gtmMeta.openButtonSource;
        },
        resetMainLeadData: () => {
            return initialState;
        },
        setMainLeadData: (state, action: PayloadAction<MainLeadDataPayload>) => {
            state.vendorId = action.payload.vendorId;
            state.offerId = action.payload.offerId || initialState.offerId;
            state.propertyId = action.payload.propertyId || initialState.vendorId;
            state.source = action.payload.source;
            state.sourceSection = action.payload.sourceSection;
            state.applicationVariant = action.payload.applicationVariant || initialState.applicationVariant;
            state.hideQuestions = action.payload.hideQuestions || initialState.hideQuestions;
            state.affiliation = action.payload.affiliation || initialState.affiliation;
            state.forceClose = action.payload.forceClose || initialState.forceClose;
            state.creditPayload = action.payload.creditPayload || initialState.creditPayload;
            state.salesOfficeId = action.payload.salesOfficeId || initialState.salesOfficeId;
            state.initialStep = action.payload.initialStep || initialState.initialStep;
            state.preventClosingWhenNoData = action.payload.preventClosingWhenNoData || initialState.preventClosingWhenNoData;
            state.customSourceSection = action.payload.customSourceSection || initialState.customSourceSection;
            state.useAdditionalFormField = action.payload.useAdditionalFormField || state.useAdditionalFormField;
            state.hourOptions = action.payload.hourOptions || initialState.hourOptions;
            state.currency = action.payload.currency || initialState.currency;
            state.topic = action.payload.topic
                ? {
                      type: action.payload.topic.type || null,
                      title: action.payload.topic.title || null,
                      message: action.payload.topic.message || null
                  }
                : initialState.topic;
            state.gtmMeta.openButtonSourceText = action.payload.gtmMeta.openButtonSourceText || initialState.gtmMeta.openButtonSourceText;
            state.gtmMeta.openButtonSource = action.payload.gtmMeta.openButtonSource || initialState.gtmMeta.openButtonSource;
        },
        setPriceConversationConsultant: (state, action: PayloadAction<MainLeadState["consultant"]>) => {
            state.consultant = action.payload;
        },
        setLeadModalMainLeadType: (state, action: PayloadAction<ILeadModalLeadType>) => {
            state.mainLeadType = action.payload;
        },
        setUseAdditionalFormField: (state, action: PayloadAction<AdditionalFormFieldType>) => {
            state.useAdditionalFormField = action.payload;
        }
    }
});

export const {openLeadModal, resetMainLeadData, setMainLeadData, setPriceConversationConsultant, setLeadModalMainLeadType, setUseAdditionalFormField} =
    mainLeadSlice.actions;
